/**
 * Returns an answer array for question type `select`
 *
 * @export
 * @param {*} answers
 * @param {*} question
 * @returns {[*]}
 */
export default function(answers, question) {
    return question.option.map((option) => ({
        key: option,
        name: option,
        user: answers.filter((answer) => answer.value.includes(option))
    }))
}
